import { useStore } from "@nanostores/react";
import { useRouter } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { dataStore, filteredValuesStore, selectedValueStore, setTypeValues, updateUrl } from "../../_utils/searchStore";
import type { Value } from "../../_utils/types";
import { MultiSelect } from "./MultiSelect";

export const DesktopSpeakers = () => {
  const router = useRouter();
  const selectedSpeakers = useStore(filteredValuesStore("speakers"));
  const [localSpeakers, setLocalSpeakers] = useState(selectedSpeakers);
  const selectedSpeakersRef = useRef(selectedSpeakers);
  const data = useStore(dataStore);

  useEffect(() => {
    const isDiff = () => {
      const oldS = selectedSpeakersRef.current.sort((a, b) => a.value.localeCompare(b.value));

      const newS = selectedSpeakers.sort((a, b) => a.value.localeCompare(b.value));

      if (oldS.length !== newS.length) return true;

      for (let index = 0; index < newS.length; index++) {
        if (oldS[index] !== newS[index]) return true;
      }

      return false;
    };

    if (isDiff()) {
      selectedSpeakersRef.current = selectedSpeakers;
      setLocalSpeakers(selectedSpeakers);
    }
  }, [selectedSpeakers]);

  const handleChange = (newValue: Value, directUpdate = false) => {
    let newSpeakers: Array<Value> = [];
    if (localSpeakers.some((lt) => lt.value === newValue.value)) {
      newSpeakers = localSpeakers.filter((lt) => lt.value !== newValue.value);
    } else {
      newSpeakers = [...localSpeakers, newValue];
    }

    setLocalSpeakers(newSpeakers);

    if (directUpdate) {
      if (selectedValueStore.get()?.value === newValue.value) {
        selectedValueStore.set(null);
      }

      setTypeValues("speakers", newSpeakers);
      updateUrl(router);
    }
  };

  const handleValidate = () => {
    setTypeValues("speakers", localSpeakers);
    updateUrl(router);
  };

  const handleClear = () => {
    setTypeValues("speakers", []);
    updateUrl(router);
  };

  const speakers = [
    ...selectedSpeakers
      .filter((s) => !data?.speakers.some((t) => t.key === s.value))
      .map((s) => ({
        value: s.value,
      })),
    ...(data?.speakers.map((t) => ({ value: t.key })) || []),
  ];

  return (
    <MultiSelect
      placeholder="Conférenciers"
      type="speakers"
      onChange={handleChange}
      onValidate={handleValidate}
      onClear={handleClear}
      localValues={localSpeakers}
      selectedValues={selectedSpeakers}
      values={speakers.map((d) => ({ label: d.value, value: d.value }))}
    />
  );
};
